export const TABLE_HIERARCHY_FIELD = 'ParentId'
export const TABLE_KEY_FIELD = 'EntryId'
